import styled from 'styled-components';

import { ListContainer } from '@r1-frontend/ui-react/experimental/containers';

export const TotalInfo = styled(ListContainer)`
    width: 100%;
`;

export const PriceWrap = styled(ListContainer)`
    align-items: center;
`;
